import _Backdrop from "@material-ui/core/esm/Backdrop";
import _ButtonBase from "@material-ui/core/esm/ButtonBase";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import { useStyles } from "./ImagesCarouselStyles";
import { useImagesCarousel } from "./hooks/useImagesCarousel";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { Video } from "./Video";
import { BottomPreview } from "./BottomPreview";

var _ref = /*#__PURE__*/_jsx(NavigateBeforeIcon, {});

var _ref2 = /*#__PURE__*/_jsx(NavigateNextIcon, {});

var _ref3 = /*#__PURE__*/_jsx(BottomPreview, {});

const ImagesCarousel = () => {
  const classes = useStyles();

  const _useImagesCarousel = useImagesCarousel(),
        visible = _useImagesCarousel.visible,
        handleHide = _useImagesCarousel.handleHide,
        selected = _useImagesCarousel.selected,
        next = _useImagesCarousel.next,
        previous = _useImagesCarousel.previous,
        handleNext = _useImagesCarousel.handleNext,
        handlePrevious = _useImagesCarousel.handlePrevious;

  return !!selected ? _jsx(_Backdrop, {
    className: classes.backdrop,
    open: visible,
    onClick: handleHide
  }, void 0, _jsx(_ButtonBase, {
    onClick: handlePrevious,
    className: "".concat(classes.navigationButton, " before")
  }, void 0, !!previous && _ref), selected.type === 'image' && _jsx("img", {
    className: classes.media,
    src: selected.content,
    alt: selected.id
  }), selected.type === 'video' && _jsx(Video, {
    className: classes.media,
    src: selected.content
  }), _jsx(_ButtonBase, {
    onClick: handleNext,
    className: "".concat(classes.navigationButton, " next")
  }, void 0, !!next && _ref2), _ref3) : null;
};

export { ImagesCarousel };